// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1UKnb","name":"styles_name__2Tz-t","phone":"styles_phone__6C4Su"};